import React, { Fragment, useState, useEffect } from "react";
import Header from "../common/header";
import Footer from "../common/footer";
import EventsInnerBanner from "./events-inner-banner";

import EventsDiscription from "./events-inner-descriptions";
import LatestEventsGallery from "./events-inner-gallery";
import LatestEvents from "./latest-events";
import { useParams } from "react-router-dom";

import * as apiUrl from "../../apiUrl";

import logo from "../../assets/marquis-logo.svg";

function EventsInnerPage() {
  const { slug } = useParams();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/events/event-inner-pages/${slug}`
        );
        if (!response.ok) {
          throw new Error("Event not found");
        }
        const data = await response.json();
        setEvent(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching event:", error);
        setLoading(false);
      }
    };

    fetchEvent();
  }, [slug]);

  if (loading) {
    return (
      <div className="loading-container">
        <img src={logo} alt="Loading" className="loading-logo" />
      </div>
    );
  }

  if (!event) {
    return <p>Event not found.</p>;
  }

  return (
    <Fragment>
      <Header />
      <EventsInnerBanner
        bannerImage={event.banner_image}
        title={event.event_title}
        description={event.description}
      />
      <LatestEventsGallery       
      imageGallery={event.image_gallery}
      videoGallery={event.video_gallery}/>
      {/* <EventsDiscription
        title={event.event_title}
        description={event.description}
        centerImage={event.center_image}
      /> */}
      <LatestEvents />
      <Footer />
    </Fragment>
  );
}
export default EventsInnerPage;
